import { createContext, useContext } from 'react';

import { type MobileMainIdentifierValues } from 'bundles/composable-page-header/constants';

export type ToSubPage = (id: MobileMainIdentifierValues) => void;
export type ToParentPage = (id: MobileMainIdentifierValues) => void;

const MobileNavigationContext = createContext<{
  toSubPage?: ToSubPage;
  toParentPage?: ToParentPage;
  closeMobileMenu?: () => void;
}>({
  toSubPage: () => {},
  toParentPage: () => {},
  closeMobileMenu: () => {},
});

export const useMobileToSubPage = () => {
  return useContext(MobileNavigationContext).toSubPage;
};

export const useMobileToParentPage = () => {
  return useContext(MobileNavigationContext).toParentPage;
};

export const useCloseMobileMenu = () => {
  return useContext(MobileNavigationContext).closeMobileMenu;
};

export default MobileNavigationContext;
